import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((order, index) => {
        const product = order?.Product;
        const orders = order?.Order;
        const customer = order.Order?.Customer;

        // console.log("checking data in product", order);

        if (product) {
          const row = {
            id: index,
            picture: product.Pictures.map((picture) => ({
              id: picture.id,
              picture: picture.pic
                .split("http")
                .filter(Boolean)
                .map((url) => `http${url.trim()}`),
            })),
            product_id: product.product_id,
            product_code: product.product_code,
            product_name: product.product_name,
            category_id: product.category_id,
            detail: product.detail,
            blemishes: product.blemishes,
            size: product.size,
            price: product.price,
            total_price: product.total_price,
            total_amount: product.total_amount,
            created_date: moment(order.created_date).format(
              "DD/MM/YYYY\n เวลา HH:mm:ss น."
            ),
            updated_date: moment(order.updated_date).format(
              "DD/MM/YYYY\n เวลา HH:mm:ss น."
            ),
            return_date: order.return_date
              ? moment(order.return_date).format(
                  "DD/MM/YYYY\n เวลา HH:mm:ss น."
                )
              : null,
            customer_id: customer?.id,
            customer_name: customer?.name,
            idcard: customer?.idcard,
            customer_image: customer?.image,
            customer_address: customer?.address,
            customer_phonenumber: customer?.phonenumber,
            prefix: customer.prefix || "",
            nationality: customer.nationality || "",
            order_status: order.status_id,
            lenting_amount: order.lenting_amount,
            order_total_price: order.total_price,
            order_price: order.price,
            order_id: order.order_id,
            order_borrow_id: order.id,
            order_status_id: orders.order_status,
          };

          rows.push(row);
        }

        console.log("check row display in product", rows);
      });
    }

    // console.log("this is a data", rows);

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
